
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" data-name="Calque 1" viewBox="0 0 512 512"><g data-name="Illustration 5"><path d="M408.78 448.09H386.5c0-179.36-148-325.28-329.91-325.28v-22.28c194.2 0 352.19 155.91 352.19 347.56Z" class="cls-1"/><path d="M424.18 328.48C397.43 216 306.27 122 192 89.2l5.12-17.84C317.73 106 414 205.23 442.24 324.19ZM441.31 222.87c-27.55-60.08-74.49-112.46-132.17-147.51l7.72-12.7c60.19 36.58 109.18 91.27 138 154Z" class="cls-1"/></g></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    